import { useEffect } from "react";
import useTrees from "../../../../../../Hooks/useTrees";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { tunnelTokenId } from "../../Actions/getMachineStatus";
import loadRepositoryRoot from "../../Actions/loadRepositoryRoot";
import { passFieldId } from "../Blocked/PassField";
import SelectionNode from "./SelectionNode/SelectionNode";

const Repository = ({ id, root, c365ID }) => {
  const { auth, dispatch, UI } = useUIBp();
  const { server, M365server } = auth;
  const tunnelToken = UI[tunnelTokenId] ?? "";
  const { value: password } = UI[passFieldId] ?? "";
  const trees = useTrees();
  const tree = trees[root];

  // console.log("tunnel token in repository", tunnelToken);

  useEffect(() => {
    if (tunnelToken) {
      dispatch(
        loadRepositoryRoot({
          server,
          M365server,
          tunnelToken,
          cpassword: password,
          repository: id,
          path: root,
          c365ID,
        })
      );
    }
  }, [dispatch, server, M365server, tunnelToken, password, id, root, c365ID]);

  let rootNodeData = tree
    ? tree[0]
    : {
        backup: 0,
        childrenIdx: [],
        idx: 0,
        isDir: true,
        name: root,
        parentIdx: null,
        status: 0,
      };

  return (
    <SelectionNode
      {...rootNodeData}
      {...{ level: 0, root, repo: id, path: "", c365ID }}
    />
  );
};

export default Repository;
